<template>
  <div class="container">
    <div class="price-top">
         <div>
           <p>￥{{totalMoney?Number(totalMoney.receivable).toFixed(2):'0.00'}}</p>
           <p>应收金额（元）</p>
         </div>
         <div class="hr"></div>
         <div>
           <p>￥{{totalMoney?Number(totalMoney.accumulatedIncome).toFixed(2):'0.00'}}</p>
           <p>累计收款金额金额（元）</p>
         </div>
    </div>
    <!-- 明细 -->
    <div class="price-detail">
      <div class="detail-top">
       <div
         :class="show==index?'per-tab2':'per-tab'"
         v-for="(item,index) in personalList"
         @click="showTab(item,index)"
         :key="index"
       >{{item.name}}
       </div>
      </div>
      <!-- 应收款明细 -->
      <div class="detail-left" v-if="show==0">
        <div class="contentReceivable" v-for="(item,index) in receivableList" >
                <div class="title">{{item.incomeName}}</div>
                <div class="pay">¥{{item.payAmount.toFixed(2)}}</div>
          </div>
          <!-- 引入分页器 -->
          <div class="PagePagination">
            <PagePagination ref="PageFrom" :pageIndex="pageIndex" :pageSize="pageSize" :total="total"></PagePagination>
          </div>
      </div>
      <!-- 累计收款明细 -->
      <div class="detail-left" v-if="show==1">
          <div class="contentReceivable" v-for="(item,index) in accumulatedIncomeList" >
            <div class="payInfo">
              <div class="title2">{{item.payTime}}</div>
              <div class="title3">{{item.incomeName}}</div>
            </div>
            <div class="pay">¥{{item.payAmount.toFixed(2)}}</div>
          </div>
          <!-- 引入分页器 -->
          <div class="PagePagination">
            <PagePagination ref="PageFrom" :pageIndex="pageIndex" :pageSize="pageSize" :total="total"></PagePagination>
          </div>
      </div>
    </div>
  </div>
</template>

<script>
  import PagePagination from "./pagePagination/pagePagination.vue"; //引入分页器
  export default {
    name: "myPrice",
    components: {
      PagePagination,
    },
    data() {
      return {
        pageIndex: 1,
        pageSize: 10,
        total:0,
        personalList: [
          {
            name: "应收款明细",
            index: 0,
          },
          {
            name: "累计收款明细",
            index: 1,
          },
        ],
         show:0,
         totalMoney:[],   //两个金额
         receivableList:[],  //应收款
         accumulatedIncomeList:[], //累计收款
      };
    },
    created() {

       this.getTotalMoney();
       this.getMyIncome()
    },
    methods: {
      showTab(item, index) {
          this.show = index;
          this.getMyIncome()
      },
      changePageInfo(current, size, total) {
        this.pageIndex = current;
        this.pageSize = size;
        this.total = total
      },
      changePageIndex(page) {
        console.log(page);
        this.pageIndex = page;
        setTimeout(() => {
          this.getMyIncome();
        }, 100)
      },
      async getTotalMoney(){  // 收款金额总收入
        try {
          const res = await this.$http.getTotalMoney()
          console.log(res)
          if (res.code == 200) {
              this.totalMoney = res.result
          } else {
            this.$message(res.message);
          }
        } catch (e) {

          throw e
        }
      },
      async getMyIncome(){  // 收款明细
          console.log(this.pageIndex)
          try {
            let data = {
              pageNo:this.pageIndex,
              pageSize:this.pageSize,
              status:this.show
            }
            console.log(data)
            const res = await this.$http.MyIncome(data);
            if (res.code == 200) {
              this.changePageInfo(this.pageIndex,res.result.size,res.result.total)
              if(this.show==0){
                this.receivableList = res.result.records
              }else{
                this.accumulatedIncomeList = res.result.records
              }
            } else {
              this.$message(res.message);
            }
          } catch (e) {

            throw e
          }
      },
    },


  };
</script>

<style scoped="scoped" lang="less">
  .container{
     width: 900px;
     height: 544px;
    box-sizing: border-box;
  }
  .PagePagination{
    display: flex;
    justify-content: center;
  }
  .payInfo{

  }
  .detail-left{
    height: 334px;
    overflow: auto;
    padding-left: 45px;
    box-sizing: border-box;
  }
  .detail-left::-webkit-scrollbar {
    display: none
  }
  .contentReceivable{
    width: 488px;
    height: 65px;
    display: flex;
    align-items: center;
    justify-content: space-between;
    border-bottom: 1px dashed  #B2B2B2;;
  }
  .title{
    font-size: 13px;
    color: #3A3A3A;
  }
  .title2{
    font-size: 14px;
    color: #3A3A3A;
    font-weight: bold;
    margin-bottom: 4px;
  }
  .title3{
    font-size: 12px;
    color: #C7C7C7;
  }
  .pay{
    font-size: 15px;
    color: #3A3A3A;
    font-weight: bold;
  }
  .detail-top{
    width: 100%;
    height: 52px;
    border-bottom: 1px solid #C7C7C7;
    display: flex;
    align-items: center;
    font-size: 16px;
    color: #3A3A3A;
  }
  .per-tab{
    margin: 0 45px;
    height: 100%;
    line-height: 52px;
  }
  .per-tab2{
    margin: 0 45px;
    border-bottom: 2px solid #707070;
    height: 100%;
    line-height: 52px;
    font-weight: bold;
  }
  .price-detail{
    width: 100%;
    background-color: #FFFFFF;
  }
  .price-top{
    width: 100%;
    height: 158px;
    background-image: url(../../static/image/userinfo/price.png) ;
    background-size:100%;
    padding: 0 0 0 80px;
    display: flex;
    align-items: center;
    box-sizing: border-box;
  }
  .price-top>div:nth-of-type(1){
    margin-right: 60px;
  }
  .price-top>div:nth-of-type(2){
    margin-right: 60px;
  }
  .price-top>div>p:nth-of-type(1){
    font-size: 24px;
    font-family: PingFang SC;
    font-weight: 800;
    line-height: 33px;
    color: #C79771;

  }
  .price-top>div>p:nth-of-type(2){
   font-size: 14px;
   font-family: PingFang SC;
   font-weight: 500;
   line-height: 20px;
   color: #3A3A3A;
  }
  .hr{
    width: 0px;
    height: 42px;
    border: 1px solid #C79771;
    opacity: 1;
  }
</style>



// WEBPACK FOOTER //
// src/components/myPrice.vue